import { SagaIterator } from 'redux-saga';
import { put, select, takeLatest } from 'redux-saga/effects';

import { UpdateExplorerDisplayModeAction, updateExplorerDisplayModeInternal } from '~src/spacesPlatform/actions/DisplaySettingsActions';
import { selectDisplaySettings } from '~src/spacesPlatform/selectors/DisplaySettingsSelectors';
import { DisplaySettings } from '~src/spacesPlatform/state/DisplaySettingsState';

import { Messages } from '../../codegen/Localize';
import { WindowLocationService } from '../../commonInfra/services/WindowLocationService';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { UpdateDisplayModeRequest } from '../../ts/ServerApi/requests/UpdateDisplayModeRequest';
import { UpdateExplorerDisplayMode } from '../actions/AppActionTypes';
import { requestFailed } from '../actions/RequestFailedAction';
import * as DisplaySettingsUrlBindings from '../content/DisplaySettingsUrlBindings';

export function* rootDisplayModeSaga(): SagaIterator {
  yield takeLatest(UpdateExplorerDisplayMode, handleUpdateDisplayMode);
}

export function* handleUpdateDisplayMode(action: UpdateExplorerDisplayModeAction): SagaIterator {
  try {
    const currentDisplaySettings: DisplaySettings = yield select(selectDisplaySettings);
    const currentDisplayMode = currentDisplaySettings.explorerDisplayMode;

    if (action.saveToServer && action.explorerDisplayMode !== currentDisplayMode) {
      saveDisplayModeToServer(action);
    }

    saveDisplayModeToUrl(action);

    // Make the update in the state
    yield put(updateExplorerDisplayModeInternal(action.explorerDisplayMode));

  } catch (e) {
    yield put(requestFailed(Messages.errorUnknown()));
  }
}

export function saveDisplayModeToServer(action: UpdateExplorerDisplayModeAction) {
  WebHttpClient.sendRequest(new UpdateDisplayModeRequest({ displayMode: action.explorerDisplayMode }));
}

/**
 * If Current URL is https://qa-near/#/explore?mode=list
 * change to https://qa-near/#/explore?mode=thumbnail
 *
 * If Current URL is https://qa-near/#/explore
 * doesn't do anything
 */
 export function saveDisplayModeToUrl(action: UpdateExplorerDisplayModeAction) {
  const queryString = WindowLocationService.getHashQueryObject() as { [key: string]: string };
  if (queryString[DisplaySettingsUrlBindings.DisplayModeUrlKey]) {
    WindowLocationService.setHashQueryParameter(DisplaySettingsUrlBindings.DisplayModeUrlKey, action.explorerDisplayMode);
  }
}
